module.exports = __webpack_public_path__ + "static/media/SWT_06.f6605abd.jpeg";